// POPUP THANH TOÁN — hiện ngay sau khi khách bấm "Mua ngay", không rời khỏi màn đang đứng.
//
// Sếp Phú chốt 28/08/2026: "UI show popup nội dung qrcode cần chuyển khoản". Cố ý KHÔNG điều
// hướng sang trang khác: khách đang ở giữa một việc (xem Hộp thư, xem kho ứng dụng), bắt họ rời
// trang để trả tiền rồi tự tìm đường quay lại là chỗ dễ bỏ cuộc nhất của cả luồng mua.
//
// Đóng popup KHÔNG huỷ đơn — đơn vẫn sống, tiền về vẫn kích hoạt, và mở lại xem được ở trang
// đơn hàng. Nói rõ điều đó ngay trên popup, nếu không khách sẽ sợ không dám tắt.

import { Trans, useLingui } from '@lingui/react/macro';
import { Loader2 } from 'lucide-react';
import Modal from '../common/Modal';
import {
  useSelfOrder, useNotifyWhenActive, SelfOrderBody, SelfOrderSummary, StatusBadge,
} from './selfOrderView.jsx';

export default function SelfOrderPaymentModal({ orderId, isOpen, onClose, onGoSeats, orderHref }) {
  // Đóng popup thì NGỪNG hỏi máy chủ — popup đóng vẫn poll 30 giây một lần là rò rỉ đúng nghĩa,
  // và không ai nhìn thấy kết quả.
  const { t } = useLingui();
  const q = useSelfOrder(orderId, { enabled: isOpen });
  const order = q.data;
  useNotifyWhenActive(order?.status);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={order?.item_name || t`Thanh toán`} size="lg">
      {q.isLoading || !order ? (
        <div className="flex items-center justify-center gap-2 py-12 text-gray-500 text-sm">
          <Loader2 className="w-4 h-4 animate-spin" /> <Trans>Đang tạo đơn hàng…</Trans>
        </div>
      ) : (
        <div className="space-y-4">
          <div className="flex flex-wrap items-center justify-between gap-2">
            <SelfOrderSummary order={order} />
            <StatusBadge status={order.status} />
          </div>

          <SelfOrderBody order={order} onGoSeats={onGoSeats} compact />

          <div className="text-[12.5px] text-gray-500 pt-1">
            <Trans>Đóng cửa sổ này không huỷ đơn — tiền về là gói tự kích hoạt.</Trans>
            {orderHref && (
              <> <a href={orderHref} className="text-blue-600 hover:underline"><Trans>Mở trang đơn hàng</Trans></a></>
            )}
          </div>
        </div>
      )}
    </Modal>
  );
}
